import 'bootstrap'
import 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import swal from 'sweetalert2'
import Request from './request'
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js'

//Required Stylesheets
import '@/assets/icons/icofont/css/icofont.css'
import '@/assets/icons/themify-icons/themify-icons.css'
import '@/assets/css/jquery.mCustomScrollbar.css'
import '@/assets/vendors/datatables.net-bs4/css/responsive.bootstrap4.min.css'
import '@/assets/css/style.css'

import Paginate from 'vuejs-paginate'


//Required JS
// import '@/assets/js/SmoothScroll.js'
import '@/assets/js/pcoded.min.js'
import '@/assets/js/demo-12.js'
import '@/assets/js/script.js'
//import '@/assets/js/user-profile.js'


Vue.config.productionTip = false
Vue.use(DatatableFactory)


Vue.component('paginate', Paginate)

Vue.prototype.$socket = Request
Vue.prototype.$swal = swal

export const bus = new Vue()

router.beforeEach((to, from, next) => {
	if(to.meta.requiresAuth){
		if (store.getters.isLoggedIn) {
			next()
			return
		}
		next('/') 
	} else {
		next() 
	}
})


//GENERAL FUNCTIONS

var deleteItem = (item_id, type)=>{
            
    return new Promise((resolve, reject)=>{
    	if(item_id !== null && type !== null){

	        var c = confirm("Are you sure you want to delelte this item?")

	        if(c == true){
	            var request = {
	                id: item_id,
	                what: type
	            }

	            Request.makeDeleteRequest(request)
	            	.then((response)=>{
	            		swal.fire('', 'Deleted', 'success')
	            	})
	            	.catch((error)=>{
	            		console.log(error)
	            	})
	        }
    	}
	})
}

var editItem = (data, type)=>{
            
    return new Promise((resolve, reject)=>{
    	if(data !== null && type !== null){

            var request = {
                data: data,
                what: type
            }

            socket.emit('editItem', request)

            socket.once('editItemResponse', (response) => {
                if(response.type == type){
                    if(response.data.status == 'true'){
                    	resolve('success')
                    } else {
                       reject('error')
                    }
                }
            })

    	}
	})
}

var capitalizeWords = (s) => {
	return s
	    .toLowerCase()
	    .split(' ')
	    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
	    .join(' ')
}

Object.byString = function(o, s) {
	//Get JSON path from string
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}


var checkPerm = (perm) => {
	return Object.byString(store.getters.user_permissions, perm)
}


//Add to Vue prototypes

Vue.prototype.$capitalizeWords = capitalizeWords
Vue.prototype.$editItem = editItem
Vue.prototype.$deleteItem = deleteItem
Vue.prototype.$checkPerm = checkPerm
Vue.prototype.$store = store


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
